package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.times

object GrowHeightAnimation {
    object Vars {
        val fromBase by StyleVariable(100.percent)
        val factor by StyleVariable<Number>(1)
    }

    val Frames = Keyframes {
        from { Modifier.height(Vars.fromBase.value()) }
        to { Modifier.height(Vars.fromBase.value() * Vars.factor.value()) }
    }
}
